import * as color from "../../constants/color";
import * as texchangePropTypes from "../../texchangePropTypes";
import PageTitle from "../text/PageTitle";
import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import * as officesApi from "../../lib/api/offices";
import supportPng from "../../images/supportImage.jpg";
import { ReactComponent as SupportIcon } from "../../images/nav-support.svg";
import { ReactComponent as ChevronDown } from "../../images/SVGs/chevron-down.svg";
import Modal from "../Modal";
import ActionButton from "../ActionButton";

const styles = StyleSheet.create({
    content: {
        paddingRight: 10,
        paddingBottom: 80,
        ":after": {
            content: '""',
            display: "table",
            clear: "both",
        },
    },
    contentSection: {
        width: "100%",
        padding: 0,
        backgroundColor: color.white,
        borderTop: `8px solid ${color.mediumRed}`,
        marginBottom: 20,
    },
    titleSection: {
        heigth: 64,
        backgroundColor: color.white,
    },
    photoHolder: {
        positon: "relative",
        height: 350,
        overflow: "hidden",
    },
    photo: {
        width: "100%",
    },
    photoCallout: {
        position: "absolute",
        top: 340,
        left: 30,
        padding: 20,
        fontSize: 22,
        backgroundColor: color.borderBackgroundGray,
        opacity: 0.8,
        color: color.white,
    },
    table: {
        width: "100%",
        border: `1px solid ${color.darkGray}`,
        borderRadius: 4,
        borderCollapse: "separate",
        borderSpacing: 4,
        backgroundColor: color.lightGray4,
        fontSize: 18,
        textAlign: "left",
    },
    tableCell: {
        color: color.tableText,
        padding: "4px 8px",
        backgroundColor: color.lightGray5,
    },
    tableCellIcon: {
        backgroundColor: color.white,
        padding: 35,
    },
    tableCellLink: {
        color: color.darkRed,
        padding: "8px",
        backgroundColor: color.white,
    },
    chevron: {
        pointerEvents: "none",
        transform: "rotate(-90deg)",
        display: "in-line",
        width: 15,
        height: 15,
    },
    padTop: {
        paddingTop: 15,
    },
    padBottom: {
        paddingBottom: 15,
    },
    padBottom40: {
        paddingBottom: 40,
    },
    padLeft40: {
        paddingLeft: 40,
    },
    padRight40: {
        paddingRight: 40,
    },
    noWrap: {
        whiteSpace: "nowrap",
    },
    info: {
        display: "flex",
        alignItems: "top center",
        justifyContent: "center",
    },
    infoBox: {
        maxWidth: "650px",
        margin: 80,
    },
    infoBoxBottom: {
        marginBottom: "40px !important",
    },
    icon: {
        fill: color.mediumRed,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        width: 65,
        height: 54,
    },
    infoText: {
        padding: 0,
    },
    bold: {
        fontWeight: "bold",
    },
    modalContent: {
        width: "90vw",
        height: "80vh",
        padding: 24,
    },
    modalButtonContainer: {
        marginTop: 6,
        marginLeft: 10,
        display: "flex",
        justifyContent: "space-between",
    },
    modalButton: {
        width: 150,
    },
});

const strings = {
    title: "Support",
};

export default class SupportScreen extends Component {
    static propTypes = {
        history: texchangePropTypes.history.isRequired,
    };

    state = {
        loading: false,
        contact: "",
        phone: "",
        email: "",
        explanation: "",
        showModal: false,
        videoName: "",
        videoId: "",
        brainSharkUrl: "",
    };

    componentDidMount() {
        this._mounted = true;
        this.setState({ loading: true });
        officesApi.getSupportInfo().then(result => {
            this.setState({ loading: false });
            if (result && this._mounted) {
                this.setState({
                    contact: result.supportContact,
                    phone: result.supportPhone,
                    email: result.supportEmail,
                    explanation: result.supportExplanation,
                });
            }
        });
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    render() {
        const {
            contact,
            phone,
            email,
            explanation,
            loading,
            showModal,
            videoName,
            videoId,
            brainSharkUrl,
        } = this.state;

        const videoTitle = "Rating Hub - " + videoName;
        const videoUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";

        return (
            <div className={css(styles.content)}>
                <Modal show={showModal && !loading} header={videoTitle} taller={true}>
                    <div className={css(styles.modalContent)}>
                        <iframe
                            width="100%"
                            height="100%"
                            src={brainSharkUrl === "" ? videoUrl : brainSharkUrl + "?dm=1"}
                            frameBorder="0"
                            allow="autoplay; encrypted-media; fullscreen;"
                            allowFullScreen="allowFullScreen"
                            mozallowfullscreen="mozallowfullscreen"
                            msallowfullscreen="msallowfullscreen"
                            oallowfullscreen="oallowfullscreen"
                            webkitallowfullscreen="webkitallowfullscreen"
                        ></iframe>
                    </div>
                    <div className={css(styles.modalButtonContainer)}>
                        <ActionButton
                            aStyles={styles.modalButton}
                            label="Close"
                            // invertColor={true}
                            type="button"
                            onClick={() => this.setState({ showModal: false, brainSharkUrl: "" })}
                        />
                    </div>
                </Modal>
                <div className={css(styles.contentSection)}>
                    <div className={css(styles.titleSection)}>
                        <PageTitle>{strings.title}</PageTitle>
                    </div>
                    <div className={css(styles.photoHolder)}>
                        <div className={css(styles.photoCallout)}>Coming soon: FAQs, and more!</div>
                        <img src={supportPng} alt="Support" className={css(styles.photo)} />
                    </div>
                    <div className={css(styles.info)}>
                        <div className={css(styles.infoBox, styles.infoBoxBottom)}>
                            <div className={css(styles.infoText)}>
                                <table className={css(styles.table)}>
                                    {contact || phone || email ? (
                                        <tbody>
                                            <tr>
                                                <td
                                                    className={css(styles.tableCellIcon)}
                                                    rowSpan="5"
                                                >
                                                    <SupportIcon className={css(styles.icon)} />
                                                </td>
                                            </tr>
                                            {contact ? (
                                                <tr>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            styles.padTop,
                                                            styles.noWrap,
                                                        )}
                                                    >
                                                        Support contact:
                                                    </td>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            styles.padTop,
                                                            styles.bold,
                                                        )}
                                                    >
                                                        {contact}
                                                    </td>
                                                </tr>
                                            ) : null}
                                            {phone ? (
                                                <tr>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            contact ? "" : styles.padTop,
                                                            styles.noWrap,
                                                        )}
                                                    >
                                                        Support phone:
                                                    </td>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            contact ? "" : styles.padTop,
                                                            styles.bold,
                                                        )}
                                                    >
                                                        {phone}
                                                    </td>
                                                </tr>
                                            ) : null}
                                            {email ? (
                                                <tr>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            explanation ? "" : styles.padBottom,
                                                            styles.noWrap,
                                                        )}
                                                    >
                                                        Support email:
                                                    </td>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            explanation ? "" : styles.padBottom,
                                                            styles.bold,
                                                        )}
                                                    >
                                                        {email}
                                                    </td>
                                                </tr>
                                            ) : null}
                                            {explanation ? (
                                                <tr>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            styles.padBottom,
                                                        )}
                                                    >
                                                        &nbsp;
                                                    </td>
                                                    <td
                                                        className={css(
                                                            styles.tableCell,
                                                            styles.padBottom,
                                                            styles.bold,
                                                        )}
                                                    >
                                                        {explanation}
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </tbody>
                                    ) : (
                                        <tbody>
                                            <tr>
                                                <td
                                                    className={css(styles.tableCellIcon)}
                                                    rowSpan="2"
                                                >
                                                    <SupportIcon className={css(styles.icon)} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    className={css(
                                                        styles.tableCell,
                                                        styles.padTop,
                                                        styles.padBottom,
                                                    )}
                                                >
                                                    &nbsp;
                                                </td>
                                                <td
                                                    className={css(
                                                        styles.tableCell,
                                                        styles.padTop,
                                                        styles.padBottom,
                                                    )}
                                                >
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: explanation,
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    )}
                                </table>
                            </div>
                        </div>
                        {/*<div className={css(styles.infoBox)}>
                            <div className={css(styles.infoText)}>
                                <table className={css(styles.table)}>
                                    <tbody>
                                        <tr>
                                            <td className={css(styles.tableCell, styles.padTop, styles.noWrap)}>Support videos:</td>
                                        </tr>
                                        <tr>
                                            <td className={css(styles.tableCellLink, styles.bold)} onClick={() => this.setState({ showModal: true, videoName: "Introduction", videoId: "SUkGkxeP8ok" })}><ChevronDown className={css(styles.chevron)} /> A Quick Introduction</td>
                                        </tr>
                                        <tr>
                                            <td className={css(styles.tableCellLink, styles.bold)} onClick={() => this.setState({ showModal: true, videoName: "A Quick Cost Comparison", videoId: "cfAi0EZKPac" })}><ChevronDown className={css(styles.chevron)} /> A Quick Cost Comparison Quote</td>
                                        </tr>
                                        <tr>
                                            <td className={css(styles.tableCellLink, styles.bold)} onClick={() => this.setState({ showModal: true, videoName: "Favorites", videoId: "-pesDRbwHrs" })}><ChevronDown className={css(styles.chevron)} /> How to Use Favorites</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>*/}
                    </div>
                    <div>
                        <div>
                            <div
                                className={css(
                                    styles.infoText,
                                    styles.padBottom40,
                                    styles.padRight40,
                                    styles.padLeft40,
                                )}
                            >
                                <table className={css(styles.table)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.contentSection,
                                                )}
                                                colSpan="2"
                                            >
                                                <div className={css(styles.titleSection)}>
                                                    <PageTitle>{`Watch & Learn With These Videos:`}</PageTitle>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "High-Level Overview",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/ratinghubhighleveloverview",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} />{" "}
                                                High-Level Overview:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                Get a high-level overview of the Rating Hub
                                                streamlined quoting process, designed to enhance
                                                efficiency and accuracy.
                                            </td>
                                        </tr>

                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "Getting Started",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/ratinghubgetstarted",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} />{" "}
                                                Getting Started:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                Now that you’ve seen the overview, here’s how to get
                                                started with the Rating Hub and move into quoting
                                                with ease.
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "Current & Renewal Proposal",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/ratinghubcurrentandrenewal",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} />{" "}
                                                Current & Renewal Proposal:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                Learn how to create a clear, side-by-side comparison
                                                of current and renewal plans, along with alternative
                                                carrier options tailored to what is needed.
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "ACA Worksheets",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/ratinghubacaworksheets",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} /> ACA
                                                Worksheets:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                This demo shows you how to generate personalized ACA
                                                worksheets in the Rating Hub, helping employees
                                                clearly understand healthcare costs and
                                                contributions.
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "Favorites Feature",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/ratinghubfavoritesfeature",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} />{" "}
                                                Favorites Feature:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                Explore how to use the Favorites feature in the
                                                Rating Hub to save preferred plans, making future
                                                quote selections more efficient.
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "Output Options",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/outputoptions",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} />{" "}
                                                Output Options:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                Emerson Rogers demonstrates how to use the proposal
                                                builder within the Rating Hub to review and
                                                customize proposal options. The tool allows
                                                tailoring outputs based on the group’s selected
                                                rating methods and products.
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "Re-Quote & New Proposal Demo",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/ratinghubrequoteandnewproposal",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} />{" "}
                                                Re-Quote & New Proposal Demo:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                Learn how to quickly update and re-quote proposals
                                                in the Rating Hub, saving time by making it easy to
                                                explore new options or revise existing quotes.
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName:
                                                        "Single Plan Spreadsheet Builder – Composite",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/singleplanspreadsheetbuilder",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} />{" "}
                                                Single Plan Spreadsheet Builder – Composite:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                This video introduces the Rating Hub’s single plan
                                                and single option spreadsheet builders, giving
                                                flexible offline tools to present plan details
                                                clearly and efficiently.
                                            </td>
                                        </tr>
                                        <tr
                                            onClick={() =>
                                                this.setState({
                                                    showModal: true,
                                                    videoName: "Plan Filters",
                                                    brainSharkUrl:
                                                        "https://www.brainshark.com/erc/ratinghubplanfilters",
                                                })
                                            }
                                        >
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.noWrap,
                                                )}
                                            >
                                                <ChevronDown className={css(styles.chevron)} /> Plan
                                                Filters:
                                            </td>
                                            <td
                                                className={css(
                                                    styles.tableCell,
                                                    styles.padTop,
                                                    styles.bold,
                                                )}
                                            >
                                                Discover the plan filter options in the Rating Hub,
                                                showing how to quickly narrow down plan choices to
                                                best fit what is needed.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
